import React from 'react'
import ReactLoading from 'react-loading'

const Loading = () => (
        <ReactLoading type="spinningBubbles" color="#79ff4d" />
)

export default Loading
